module.exports = __webpack_public_path__ + "img/哔哩哔哩.fb559841.png";